import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

function AllOrdersPage() {
    const [orders, setOrders] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const handleOrderData = async () => {
            try {
                const response = await axios.get(`${API_URL}/all-orders`);
                const deliveredOrders = response.data.filter(order => order.status === 'delivered')
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by newest first
                setOrders(deliveredOrders);
            } catch (err) {
                toast.error("Failed to fetch orders. Please try again.");
            }
        };

        handleOrderData();
    }, []);

    return (
        <Fragment>
            
            <div className="container-fluid adma">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <h2>Delivered Orders</h2>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Mobile</th>
                                    <th>Items</th>
                                    <th>Total Price</th>
                                    <th>Address</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.length > 0 ? (
                                    orders.map((item) => (
                                        <tr key={item._id}>
                                            <td>{item.address?.name || "N/A"}</td>
                                            <td>{item.mobile || "N/A"}</td>
                                            <td>{item.items?.length || 0}</td>
                                            <td>₹{item.totalAmount || "N/A"}</td>
                                            <td>
                                                {item.address ? (
                                                    `${item.address.house}, ${item.address.area}, ${item.address.landmark}`
                                                ) : "N/A"}
                                            </td>
                                            <td>{item.status}</td>
                                            <td>
                                                <Link to={`/admin/orders-details/${item._id}`} className="action-link">Details</Link>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="7" className="text-center">No delivered orders found.</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </Fragment>
    );
}

export default AllOrdersPage;
